export const phoneValidatorRegex: string = '\\(\\d{2}\\)\\s\\d{4,5}\\.\\d{4}';
